<template>
	<page title="System Settings">
		<v-row>
			<v-col cols="6" md="">
				<v-card
					color="success"
					class="mb-3 widget"
					dark>
					<v-overlay v-model="widgetsLoading" absolute>
						<v-progress-circular indeterminate size="32"></v-progress-circular>
					</v-overlay>

					<v-card-title class="text-h5 mb-2 font-mono">
						{{ widgets.projects.count | numeric }}
					</v-card-title>

					<v-card-subtitle><span class="text-uppercase">Total Projects</span></v-card-subtitle>
				</v-card>
			</v-col>
			<v-col cols="6" md="">
				<v-card
					color="secondary"
					class="mb-3 widget"
					dark>
					<v-overlay v-model="widgetsLoading" absolute>
						<v-progress-circular indeterminate size="32"></v-progress-circular>
					</v-overlay>

					<v-card-title class="text-h5 mb-2 font-mono">
						{{ widgets.properties.count | numeric }}
					</v-card-title>

					<v-card-subtitle><span class="text-uppercase">Total Properties</span></v-card-subtitle>
				</v-card>
			</v-col>
			<v-col cols="6" md="">
				<v-card
					color="warning"
					class="mb-3 widget"
					dark>
					<v-overlay v-model="widgetsLoading" absolute>
						<v-progress-circular indeterminate size="32"></v-progress-circular>
					</v-overlay>

					<v-card-title class="text-h5 mb-2 font-mono">
						{{ widgets.users.count | numeric }}
					</v-card-title>

					<v-card-subtitle><span class="text-uppercase">Total Users</span></v-card-subtitle>
				</v-card>
			</v-col>
			<v-col cols="6" md="">
				<v-card
					color="amber darken-3"
					class="mb-3 widget"
					dark>
					<v-overlay v-model="widgetsLoading" absolute>
						<v-progress-circular indeterminate size="32"></v-progress-circular>
					</v-overlay>

					<v-card-title class="text-h5 mb-2 font-mono">
						{{ widgets.files.size | prettyBytes }}
					</v-card-title>

					<v-card-subtitle><span class="text-uppercase">File Storage</span></v-card-subtitle>
				</v-card>
			</v-col>
			<v-col cols="6" md="">
				<v-card
					color="amber darken-3"
					class="mb-3 widget"
					dark>
					<v-overlay v-model="widgetsLoading" absolute>
						<v-progress-circular indeterminate size="32"></v-progress-circular>
					</v-overlay>

					<v-card-title class="text-h5 mb-2 font-mono">
						{{ widgets.files.count | numeric }}
					</v-card-title>

					<v-card-subtitle><span class="text-uppercase">Uploaded Files</span></v-card-subtitle>
				</v-card>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" md="3">
				<v-sheet rounded>
					<v-card outlined color="#F9F9FB">
						<v-list
							nav
							dense
							class="sidebar-nav">
							<v-list-item-group
								v-model="selectedTab"
								mandatory>
								<v-list-item
									v-for="(item, i) in tabs"
									:key="i"
									active-class="list-item-selected">
									<v-list-item-icon>
										<v-icon :color="item.color" v-text="item.icon"></v-icon>
									</v-list-item-icon>

									<v-list-item-content>
										<v-list-item-title>
											<div class="d-flex">
												<div class="align-self-center">{{ item.text }}</div>
											</div>
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</v-card>
				</v-sheet>
			</v-col>
			<v-col cols="12" md="9">
				<v-tabs v-model="selectedTab" vertical>
					<v-tab-item eager>
						<billing :settings="settings" />
					</v-tab-item>
					<v-tab-item>
						<status-table model-name="project" />
					</v-tab-item>
					<v-tab-item>
						<status-table model-name="property" />
					</v-tab-item>
					<v-tab-item>
						<status-table model-name="report" />
					</v-tab-item>
					<v-tab-item>
						<reporting :report-types="reportTypes" />
					</v-tab-item>
				</v-tabs>
			</v-col>
		</v-row>
	</page>
</template>
<script>
import Backend from '@/Layouts/Backend'
import Page from '@/Pages/Backend/Components/Page'
import Billing from '@/Pages/Backend/Settings/Billing'
import Reporting from '@/Pages/Backend/Settings/Reporting.vue'
import StatusTable from '@/Pages/Backend/Settings/StatusTable'
import api from '@/api'

export default {
	components: { Page, Billing, Reporting, StatusTable },
	layout: Backend,
	props: {
		settings: {
			type: Object,
			default: () => {}
		},
		reportTypes: {
			type: Array,
			default: () => []
		}
	},
	data () {
		return {
			widgets: {
				files: {
					count: 0,
					size: 0
				},
				projects: {
					count: 0
				},
				properties: {
					count: 0
				},
				users: {
					count: 0
				}
			},
			widgetsLoading: true,
			selectedTab: 0,
			tabs: [
				{ icon: 'mdi-card-account-details', text: 'Billing Settings', color: 'primary' },
				{ icon: 'mdi-circle', text: 'Project Statuses', color: 'success' },
				{ icon: 'mdi-circle', text: 'Property Statuses', color: 'secondary' },
				{ icon: 'mdi-circle', text: 'Report Statuses', color: 'orange darken-3' },
				{ icon: 'mdi-file-chart', text: 'Reporting Types', color: 'orange'  }
			]
		}
	},
	mounted () {
		this.getWidgets()
	},
	methods: {
		getWidgets () {
			const method = 'GET'
			const data = {}

			const url = this.route('stats.system')

			return api({
				method,
				url,
				data
			}).then(response => {
				this.widgets = response.data
				this.widgetsLoading = false
			})
		}
	}
}
</script>
